import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'
import { useNavigate } from "react-router-dom";
import logoBig from '@/assets/deny-permissions-logo.svg';

const PermissionsDenyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full p-8 flex justify-center items-center flex-col mt-[10%]">
      <img
        src={logoBig}
        alt="SLYRSA Logo"
        className="w-[268px] h-[262px] object-contain"
      />
      <p className="font-semibold text-base">
        Lo sentimos, no tienes permiso para acceder
      </p>
      <p className="text-sm">
        De momento no cuentas con permisos para ver esta información
      </p>

      <button
        type="button"
        onClick={() => navigate("/")}
        className={estiloDeBoton('primario', 'w-[240px] mt-4')}
      >
        Volver a inicio
      </button>
    </div>
  );
};

export default PermissionsDenyPage;
